import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';


const HomeAffiliate = () => {
    return (
            <div className="rn-splite-style">
                <div className="split-wrapper">
                        <div className="row no-gutters radius-10 align-items-center">
                            
                            <div className="col-lg-12 col-xl-6 col-12">
                                <div className="split-inner">
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <h4 className="title">Affiliate Outcomes:</h4>
                                    </ScrollAnimation>
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                    <p className="description"></p>
                                    </ScrollAnimation>

                                    
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <ol className="">
                                            <li>Earn commission per sale ( Commission Ratio Depends on Mutual Agreement)</li>
                                            <li>Earn 10,000–1,00,000+ BDT per referral Promote high-ticket PWU programs with huge payout potential.</li>
                                            <li>Get Monthly payouts—every 40 days Receive your commission directly to your bank account.</li>
                                            <li>Access 50+ pre-built marketing creatives Includes images, captions, landing pages, emails, and video scripts.</li>
                                            <li>Get Monthly Consulting Access With Jahid Hasan (12x per year)Learn from Jahid to Improve your Life,Business & Income.</li>
                                            <li>Unlock cash bonuses or gift at 5, 10, and 20 sales milestones.</li>
                                            <li>Get Affiliate Dashboard with real-time tracking</li>
                                        </ol>
                                    </ScrollAnimation>
                                    <ScrollAnimation 
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                        <div className="view-more-button mt--35">
                                            <Link className="btn-default" to="/affiliate">LEARN MORE</Link>
                                        </div>
                                    </ScrollAnimation>
                                </div>
                        </div>
                        <div className="col-lg-12 col-xl-6 col-12">
                                <div className="thumbnail image-left-content">
                                    <img src="./images/affiliate2.jpg" alt="split Images" />
                                </div>
                            </div>
                    </div>
                </div>
            </div>
    )
}

export default HomeAffiliate
